import { NgModule } from '@angular/core';
import { NotesListComponent } from './notes-list.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RequiredClaimDirective } from '@ews/users-management';
import { NoteDialogComponent } from './note-dialog/note-dialog.component';
import { DesignSystemModule } from '@bcl/design-system';
import { MatDialogModule } from '@angular/material/dialog';
import { IonicModule } from '@ionic/angular';
import { VoiceRecognitionComponent } from './note-dialog/voice-recognition/voice-recognition.component';

@NgModule({
  declarations: [
    NotesListComponent,
    NoteDialogComponent,
    VoiceRecognitionComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    RequiredClaimDirective,
    DesignSystemModule,
    IonicModule,
  ],
  exports: [NotesListComponent, VoiceRecognitionComponent],
})
export class NotesListModule {}
